module.exports = __webpack_public_path__ + "img/34.717cc8fc.jpg";